// @flow
import React, { useCallback, useMemo } from "react";
import FancyDropdown from "../FancyDropdown";
import DropDown from "../DropDown";
import useNativeInputs from "../../hooks/useNativeInputs";

type Props = {
  options: Array<{
    label: string,
    value: string | number,
    disabled?: boolean
  }>,
  selected: string | number,
  onChange: (string | number) => void,
  placeholder?: null | string,
  disabled?: boolean,
  id?: string,
  cypress?: string,
  label?: string,
  labelColor?: string
};

const NativeFancyDropdown = ({
  selected,
  options,
  onChange,
  placeholder,
  disabled,
  id,
  cypress,
  label,
  labelColor = "light"
}: Props) => {
  const baseClass = "c-native-fancy-dropdown";
  const useNative = useNativeInputs();

  const selectedOption = useMemo(
    () => options.find((option) => option.value === selected),
    [options, selected]
  );

  const onDropdownChange = useCallback(
    (option) => {
      onChange(option);
    },
    [onChange]
  );

  const onFancyChange = useCallback(
    (option) => {
      onChange(option.value);
    },
    [onChange]
  );

  return (
    <div className={baseClass}>
      {useNative === false ? (
        <FancyDropdown
          searchable={false}
          onOptionSelect={onFancyChange}
          selectedOption={selectedOption}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          id={id}
          cypress={cypress}
          label={label}
          labelColor={labelColor}
        />
      ) : (
        <DropDown
          onChange={onDropdownChange}
          options={options}
          value={selected}
          placeHolder={placeholder}
          disabled={disabled}
          id={id}
          cypress={cypress}
          label={label}
          labelColor={labelColor}
        />
      )}
    </div>
  );
};

NativeFancyDropdown.defaultProps = {
  error: "",
  id: null,
  cypress: null
};
export default NativeFancyDropdown;
